<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑职称"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off">
            <el-form-item label="职称全称" prop="title_name">
                <el-input type="text" v-model="ruleForm.title_name" placeholder="请输入职称全称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="排序号" prop="sort">
                <el-input type="number" v-model="ruleForm.sort" placeholder="请输入排序号 (排序值越小越前)" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";

    export default {
        created() {

            if (this.$route.query.id) {
                this.id = this.$route.query.id;
                this.ruleForm.title_name = this.$route.query.title_name;
                this.ruleForm.sort = this.$route.query.sort;
                this.ruleForm.status = parseInt(this.$route.query.status);
            } else {
                this.id = this.$route.params.id;
                this.ruleForm.title_name = this.$route.params.title_name;
                this.ruleForm.sort = this.$route.params.sort;
                this.ruleForm.status = parseInt(this.$route.params.status);
            }

        },
        mounted() {
        },
        data() {
            return {
                allHospital: [],
                ruleForm: {
                    title_name: "",
                    sort: "10",
                    status: 1,
                },
                rules: {
                    title_name: [
                        {required: true, message: "请输入职称全称", trigger: "blur"},
                    ],
                    sort: [
                        {required: true, message: "请输入排序号", trigger: "blur"},
                    ],
                    status: [
                        {required: true, message: "请选择状态", trigger: "blur"},
                    ],
                },
                is_submit: false,
            };
        },
        methods: {

            // 返回上一页
            goBack() {
                window.history.go(-1);
                // if (this.$route.query.id) {
                //     window.close();
                // } else {
                //     window.history.go(-1);
                // }
            },

            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminOperateServices',
                            'method': 'editManagerTitle',
                            'params': {
                                id: this.id,
                                title_name: this.ruleForm.title_name,
                                sort: this.ruleForm.sort,
                                status: this.ruleForm.status,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                                duration: 1500,
                                onClose: function () {
                                    window.history.go(-1);
                                    _that.is_submit = false;
                                    // _that.$router.push({
                                    //     name: "managerTitleList",
                                    //     params: {}
                                    // });
                                }
                            });
                        }).catch(()=>{
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                });
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>
